export default {
  init() {
    // JavaScript to be fired on the home page
    
    let video = $('#vimeo-video');
    let videoSrc = video.attr('src');
    let scrollStop = true
    $(window).on('scroll', function () {
      let top_of_element = video.offset().top;
      let bottom_of_element = video.offset().top + video.outerHeight();
      let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      let top_of_screen = $(window).scrollTop();

      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        if(scrollStop) {
          let autoplaySrc = videoSrc.concat('?autoplay=1&loop=1&autopause=0')
          video.attr('src', autoplaySrc)
        }
        scrollStop = false
      } else {
        scrollStop ? video.attr('src', videoSrc) : scrollStop = true
      }
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js